var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"name":"LayoutDefault"}},[_c('div',{staticClass:"About"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"contents"},[_c('div',{staticClass:"row text-justify"},[_c('div',{staticClass:"col-lg-12"},[_c('p',[_vm._v("Content coming soon...")])])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }